/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-01-20 16:04:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-16 14:23:31
 */
const BASE_URL = '/lishui-gov'
import request from '@/common/api/request'

// 订单分页查询列表
export const listByPage = params =>
  request(BASE_URL + '/govGoodsOrder/listByPage', { params })

// 审核报销状态数量统计
export const auditStatusCount = params =>
  request(BASE_URL + '/govGoodsOrder/auditStatusCount', { params })

// 审核报销
export const auditReimbursement = data =>
  request.post(BASE_URL + '/govGoodsOrder/auditReimbursement', data)

// 报销详情
export const reimbursementDetail = params =>
  request(BASE_URL + '/govGoodsOrder/reimbursementDetail', { params })

// 订单详情
export const orderDetail = params =>
  request(BASE_URL + '/govGoodsOrder/orderDetail', { params })

//  机构

// 审核报销状态数量统计
export const entStatusCount = params =>
  request(BASE_URL + '/entGoodsOrder/auditStatusCount', { params })

// 报销详情
export const entReimbursementDetail = params =>
  request(BASE_URL + '/entGoodsOrder/reimbursementDetail', { params })

// 申请报销
export const applyReimbursement = data =>
  request.post(BASE_URL + '/entGoodsOrder/applyReimbursement', data)

// 机构确认订单
export const orgConfirmOrder = params =>
  request(BASE_URL + '/govGoodsOrder/orgConfirmOrder', { params })

// 文件上传
export const fileUpload =
  process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/upload'
// 已兑现详情列表
export const cashList = params =>
  request(BASE_URL + '/govGoodsOrder/cashList', { params })
// 兑现导出
export const exportCashList = params => request.downLoad(BASE_URL + '/govGoodsOrder/exportCashList',  params)

// 取消订单 /lishui-gov/govGoodsOrder/cancelOrders
export const cancelOrders = data =>
  request.post(BASE_URL + '/govGoodsOrder/cancelOrders', data)
// 訂單導出 /lishui-gov/govGoodsOrder/downloadOrders
export const downloadOrders = params =>
  request.downLoad(BASE_URL + '/govGoodsOrder/downloadOrders', params)

// 查看资料列表
export const orderContent = params =>
  request(BASE_URL + '/govGoodsOrder/orderContent', { params })
